// Card Sliders
const featureSliders = document.querySelectorAll('.js-features-slider'),
    featureSliderNavNext = document.querySelectorAll('.js-features-next'),
    featureSliderNavPrev = document.querySelectorAll('.js-features-prev'),
    featureSliderPagination = document.querySelectorAll('.js-features-pager');

// Feature Carousels
featureSliders.forEach((el, i) => {
    const timeout = parseInt(el.dataset.timeout);

    let featureSliderOptions = {
        containerModifierClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slidesPerView: 'auto',
        watchOverflow: true,
        loop: true,
        loopedSlides: 1,
        uniqueNavElements: true,
        speed: 500,
        navigation: {
            nextEl: featureSliderNavNext[i],
            prevEl: featureSliderNavPrev[i],
            disabledClass: 'slider__button--disabled'
        },
        pagination: {
            el: featureSliderPagination[i],
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    };

    if (timeout) {
        featureSliderOptions.autplay = {
            delay: timeout
        };
    }

    const slider = new Swiper(el, featureSliderOptions);
});

const featuredStorySliders = document.querySelectorAll('.js-feature-stories'),
    swiperInstances = [],
    delay = 250;

let throttled = false;

function handleFeaturedStories() {
    if (window.innerWidth < 740) {
        // Featured Sorry Carousels
        featuredStorySliders.forEach((el, i) => {
            swiperInstances.push(new Swiper(el, {
                containerModifierClass: 'slider',
                wrapperClass: 'slider__wrapper',
                slideClass: 'slide',
                slidesPerView: 1,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            }));
        });
    } else {
        // Destroy any swiper instances
        swiperInstances.forEach(swiper => {
            swiper.destroy(true, true);
        });
    }
}

// window.resize event listener
window.addEventListener('resize', function() {
    // Only run if we're not throttled
    if (!throttled) {
        handleFeaturedStories();

        throttled = true;

        // Set a timeout to un-throttle
        setTimeout(function() {
            throttled = false;
        }, delay);
    }  
});

handleFeaturedStories();

// Gallery Sliders
const gallerySliders = document.querySelectorAll('.js-gallery-slider'),
    gallerySliderNavNext = document.querySelectorAll('.js-gallery-next'),
    gallerySliderNavPrev = document.querySelectorAll('.js-gallery-prev'),
    gallerySliderPagination = document.querySelectorAll('.js-gallery-pager');

// gallery Carousels
gallerySliders.forEach((el, i) => {
    let gallerySliderOptions = {
        containerModifierClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slidesPerView: 'auto',
        watchOverflow: true,
        uniqueNavElements: true,
        speed: 500,
        spaceBetween: 12,
        navigation: {
            nextEl: gallerySliderNavNext[i],
            prevEl: gallerySliderNavPrev[i],
            disabledClass: 'slider__button--disabled'
        },
        pagination: {
            el: gallerySliderPagination[i],
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        breakpoints: {
            740: {
              spaceBetween: 24
            }
        }
    };

    const slider = new Swiper(el, gallerySliderOptions);
});

// featured Sliders
const featuredSliders = document.querySelectorAll('.js-featured-slider'),
    featuredSliderNavNext = document.querySelectorAll('.js-featured-next'),
    featuredSliderNavPrev = document.querySelectorAll('.js-featured-prev'),
    featuredSliderPagination = document.querySelectorAll('.js-featured-pager');

// Featured Carousels
featuredSliders.forEach((el, i) => {
    let featuredSliderOptions = {
        containerModifierClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slidesPerView: 'auto',
        watchOverflow: true,
        uniqueNavElements: true,
        speed: 500,
        navigation: {
            nextEl: featuredSliderNavNext[i],
            prevEl: featuredSliderNavPrev[i],
            disabledClass: 'slider__button--disabled'
        },
        pagination: {
            el: featuredSliderPagination[i],
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    };

    const slider = new Swiper(el, featuredSliderOptions);
});